<script>

import {mapState} from 'vuex'
import VueSlider from 'vue-slider-component'

export default {
    data() {
        return {
            i_can_readily_name_my_core_values: 0,
            data : null,
        }
    },

    props: ['url', 'scaleUrl', 'scale'],


    computed: {
    },

    created() {
    },

    mounted() {
        this.getData();

        this.i_can_readily_name_my_core_values = this.scale;
    },

    watch: {
    },

    methods: {
        getData() {
            axios
                .get(this.url)
                .then(response => {
                    this.data = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        deleteItem(item) {
            axios
                .delete(item.delete_url)
                .then(response => {
                    this.data = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$refs.toastr.e("ERROR");
                });
        },

        moveUp(item) {
            axios
                .put(item.up_url)
                .then(response => {
                    this.data = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$refs.toastr.e("ERROR");
                });
        },

        moveDown(item) {
            axios
                .put(item.down_url)
                .then(response => {
                    this.data = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$refs.toastr.e("ERROR");
                });
        },

        updateScale() {
            axios
                .put(this.scaleUrl,
                    {
                        scale: this.i_can_readily_name_my_core_values,
                    }
                )
                .then(response => {
                    this.$root.$refs.toastr.s(response.data.message);
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$refs.toastr.e("ERROR");
                });
        },
    },

    components: {
        VueSlider
    }
}
</script>
